import { useState, useEffect } from "react";
import { apiGet, apiSend, errorMessage } from "./api";
import "./CreateUserModal.css";

function CreateUserModal({ onClose, onCreated }) {
  const [orgs, setOrgs] = useState([]);
  const [form, setForm] = useState({
    email: "",
    password: "",
    name: "",
    surname: "",
    phone: "",
    right_id: 2,
    status_id: 1,
    organization_id: "",
    plan: "None",
    siret: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    apiGet("/api/organizations").then(setOrgs).catch(() => setOrgs([]));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const body = {
        ...form,
        phone: form.phone.trim() || null,
        right_id: parseInt(form.right_id),
        status_id: parseInt(form.status_id),
        organization_id: form.organization_id ? parseInt(form.organization_id) : null,
        siret: form.siret.trim() || null,
      };
      await apiSend("/api/users", "POST", body, "Erreur lors de la création");
      onCreated();
      return;
    } catch (e) {
      setError(errorMessage(e, "Erreur lors de la création"));
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Créer un utilisateur</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}
          <label>Nom</label>
          <input name="name" value={form.name} onChange={handleChange} required />
          <label>Prénom</label>
          <input name="surname" value={form.surname} onChange={handleChange} required />
          <label>Email</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} required />
          <label>Téléphone (facultatif)</label>
          <input name="phone" type="tel" value={form.phone} onChange={handleChange} maxLength={20} placeholder="06 12 34 56 78" />
          <label>Mot de passe</label>
          <input name="password" type="password" value={form.password} onChange={handleChange} required />
          <label>Organisation</label>
          <select name="organization_id" value={form.organization_id} onChange={handleChange}>
            <option value="">Aucune</option>
            {orgs.map((o) => (
              <option key={o.id} value={o.id}>{o.name}</option>
            ))}
          </select>
          {form.organization_id && (
            <>
              <label>SIRET du commerce (facultatif)</label>
              <input
                name="siret"
                value={form.siret}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="123 456 789 00012"
                maxLength={20}
              />
              <p className="modal-hint">
                14 chiffres — enregistré sur l'organisation sélectionnée, il
                figurera sur ses factures.
              </p>
            </>
          )}
          <label>Rôle</label>
          <select name="right_id" value={form.right_id} onChange={handleChange}>
            <option value={1}>Admin</option>
            <option value={2}>User</option>
            <option value={3}>Sale</option>
            <option value={4}>Staff</option>
          </select>
          <label>Statut</label>
          <select name="status_id" value={form.status_id} onChange={handleChange}>
            <option value={1}>Active</option>
            <option value={4}>Pending (en attente de validation)</option>
            <option value={2}>Disabled</option>
            <option value={3}>Banned</option>
          </select>
          <label>Plan</label>
          <select name="plan" value={form.plan} onChange={handleChange}>
            <option value="None">Aucun</option>
            <option value="Default">Default</option>
            <option value="Premium">Premium</option>
            <option value="Extra">Extra</option>
          </select>
          <button type="submit" className="modal-submit" disabled={loading}>
            {loading ? "Création..." : "Créer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateUserModal;
